/**
 * @desc: 项目打款 API
 * @author: zengtiansheng
 * @update: 2018/3/20
 */
export default {
  projectAssistantList: '/qtbCompanyCenter/projectAssistant/list', //获取项目列表
  projectAssistantDel: '/qtbCompanyCenter/projectAssistant/del/id', //删除项目
  projectAssistantRecordList: '/qtbCompanyCenter/projectAssistantRecord/list', //项目账目列表
  exportExcel: '/qtbCompanyCenter/projectAssistantRecord/export/excel', //导出报表 a标签打开新页面获取
  exportSalaryExcel: '/qtbCompanyCenter/projectAssistantRecord/detail/list/export', //工资支付明细导出接口
  importExcel: '/qtbCompanyCenter/projectAssistantRecord/load/excel', //项目助手模板Excel导入
  projectAssistantAdd: '/qtbCompanyCenter/projectAssistant/add', //添加项目
  addOneProjectRecord: '/qtbCompanyCenter/projectAssistantRecord/addPojectRecord', //项目单个添加人员
  updateProjectRecord: '/qtbCompanyCenter/projectAssistantRecord/update/pojectRecord', //项目未打款时 修改项目明细单条记录
  delOneProjectRecord: '/qtbCompanyCenter/projectAssistantRecord/del/poject/record', //删除账目
  orderProjectCreate: '/qtbCompanyCenter/projectAssistant/order/project/create', //项目创建订单接口
  loadExcel: '/qtbCompanyCenter/projectAssistantRecord/load/excel', //项目助手模板Excel导入
  createSingleOrder: '/qtbCompanyCenter/projectAssistant/order/project/record/create', //项目具体账目创建订单接口
  recordWithdraw: '/qtbCompanyCenter/projectAssistantRecord/withdraw/record', //商家撤回操作打款
  projectAssistantRecordDetailList: '/qtbCompanyCenter/projectAssistantRecord/detail/list' //获取项目助手打款详细记录列表'

}



// WEBPACK FOOTER //
// ./src/views/payment/API.js